import React, { useState } from 'react'
import CardForm from './Modals/CardForm'
import { HTTP } from '../../api/resources'

export default function CardList({user, publicCards, team, newCard, cardType, cardFormat, stripeAccounts}) {
  const [cards, setCards] = useState(publicCards && publicCards.length > 0 ? publicCards : [])
  const [saving, setSaving] = useState(false)
  const [editingCard, setEditingCard] = useState(null)
  const [deletingCardId, setDeletingCardId] = useState(null)
  const [openCardForm, setOpenCardForm] = useState(false)

  const deleteCard = async (cardId) => {
    setSaving(true)

    HTTP.delete(`/public/cards/${cardType}/${user.id}/${cardId}`)
      .then((response) => {
        let updatedCards = cards.filter((card) => card.id !== cardId);
        setCards(updatedCards);
        setDeletingCardId(null);
        Alert.show('notice', 'Card deleted successfully');
      })
      .catch((error) => {
        Alert.show('error', 'Failed to delete card');
      })
      .finally(() => {
        setSaving(false);
      });
  }

  const validateCard = (cardData) => {
    let paymentLink = cardData.payment_redirect_link ? cardData.payment_redirect_link.trim() : ''

    if (cardData.use_payments && cardData.payment_method == 'external_payment_method' && paymentLink) {
      if (
        paymentLink.includes("://") ||
        paymentLink.includes(" ")
      ) {
        Alert.show(
          "notice",
          "Payment link cannot include protocol e.g https:// or spaces"
        );
        return false;
      }
    }

    if (cardData.use_payments && cardData.payment_method == 'external_payment_method' && (!paymentLink || paymentLink.length < 1)) {
      Alert.show(
        "notice",
        "Payment link cannot be blank when using team payments"
      );
      return false;
    }

    if (!cardData.title || cardData.title.length < 1) {
      Alert.show('notice', 'Title cannot be blank');
      return false 
    }

    if (cardData.use_payments && cardData.donation_type == 'monthly' && (!cardData.donation_amount || cardData.donation_amount < 2)) {
      Alert.show('notice', 'Donation amount cannot be less than $2')
      return false 
    }

    handleSubmit(cardData)
  }

  const handleSubmit = (cardData) => {
    setSaving(true)

    if (cardData.id && editingCard) {
      HTTP.patch(`/public/cards/${cardType}/${user.id}/${cardData.id}`, { public_card: cardData })
        .then((response) => {
          let updatedCards = cards.map((card) => {
            if (card.id === response.data.id) {
              return response.data;
            }
            return card;
          });
          setCards(updatedCards);
          setEditingCard(null);
          setOpenCardForm(false);
          Alert.show('notice', 'Card updated successfully');
        })
        .catch((error) => {
          Alert.show('error', 'Failed to update card');
        })
        .finally(() => {
          setSaving(false);
        });
    } else if (!cardData.id) {
      HTTP.post(`/public/cards/${cardType}/${user.id}`, { public_card: cardData })
      .then((response) => {
        setCards([response.data, ...cards]);
        setEditingCard(null);
        setOpenCardForm(false);
        Alert.show('notice', 'Card created successfully');
      })
      .catch((error) => {
        Alert.show('error', 'Failed to create card');
      })
      .finally(() => {
        setSaving(false);
      });
    }
  }

  const copyToClipboard = (url) => {
    navigator.clipboard.writeText(url)
    Alert.show('notice', 'Copied public card url to clipboard')
  }

  return (
    <div id="sponsorships-table" className="card">
        <div className="card-header flex-header">
          <div>
            <h4 className="card-title">Public Cards</h4>
            <small>Share public card to potential {team.donor_title.toLowerCase()} or leads</small>
          </div>
            <div>
              <div>
                <button onClick={() => setOpenCardForm(true)} name="button" className="btn btn-primary" disabled={saving}>
                  {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                  Create New Card
                </button>
              </div>
            </div>
          </div>
    
          {cards && cards.length > 0 &&
            <div className="list-group list-group-flush">
              {cards.map((card) => (
                <div
                  key={card.id}
                  id={`public-card-${card.id}`}
                  className="list-group-item"
                >
                  <div className="list-group-item-body">
                    <div className="list-group-item-body-main mb-2">
                      <span className="mr-1">
                        {card.title.length > 20 ? card.title.substring(0, 20) + '...' : card.title}
                      </span>
                      <a
                        href={card.url}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="fa fa-external-link"></i>
                      </a>
                    </div>
                  </div>
                  
                  <div className="list-group-item-actions">
                    <button
                      data-confirm="Are you sure? This can't be undone."
                      onClick={() => setDeletingCardId(card.id)}
                      className="btn btn-sm btn-danger"
                    >
                      Delete
                    </button>
      
                    {deletingCardId && deletingCardId == card.id && (
                      <span>
                        <button
                          onClick={() => deleteCard(card.id)}
                          className="btn btn-sm btn-danger mr-1"
                        >
                          Confirm Remove
                        </button>
                        <button
                          onClick={() => setDeletingCardId(null)}
                          className="btn btn-sm btn-outline-danger"
                        >
                          Cancel
                        </button>
                      </span>
                    )}
                  </div>
    
                  
                  <div className="list-group-item-actions">
                    <button
                      onClick={() => {setEditingCard(card); setOpenCardForm(true)}}
                      className="btn btn-sm btn-primary"
                    >
                      Edit
                    </button>
                  </div>

                  <div className="list-group-item-actions">
                    <button 
                      className="btn btn-light btn-sm btn-border" 
                      type="button" 
                      onClick={() => copyToClipboard(card.url)} 
                      disabled={!card.url}
                    >
                      <i className="fa fa-clipboard"></i>
                    </button>
                  </div>
              </div>
            ))}
            </div>
          }
    
            {openCardForm && 
              <CardForm 
                user={user}
                card={editingCard ? editingCard : newCard}
                actionType={editingCard ? 'editing' : 'creating'}
                onClose={() => {setOpenCardForm(false); setEditingCard(null)}}
                onSave={(savedCard) => validateCard(savedCard)}
                saving={saving}
                stripeAccounts={stripeAccounts}
                team={team}
                cardFormat={cardFormat}
                cardType={cardType}
              />
            }
    </div>
  )
}
